module.exports = __webpack_public_path__ + "assets/img/banner5.2ea28b24.png";